import Vue from 'vue'
import { HTTP_DELETE, HTTP_GET, HTTP_POST, HTTP_PUT } from '../const';
import {
  ADD_WHITELIST_WALLET, DELETE_WHITELIST_WALLET,
  LOAD_SETTINGS,
  UPDATE_SETTING,
} from "../const/settings";

export default {
  namespaced: true,
  state: {
    rowColors: [
      '#ffe6d7',
      '#ddffdf',
      '#d7e8ff',
      '#ffd3f8',
      '#c2f3ed',
      '#f3c2c7',
      '#e2e2c8',
      '#f8e2db',
      '#e6ddf3',
      '#b3bbb4',
    ],
    defaults: {
      roles: {
        client: 'Клиент',
        superadmin: 'Суперадмин',
        service: 'Служебный',
      },
      timeZoneOptions: {
        timeZone: "Europe/Moscow",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      },
      cryptoTypes: ['BTC', 'USDT'],
      blockchains: ['BTC', 'TRX', 'ETH'],
    },
  },
  getters: {
    roles: state => state.defaults.roles,
    timeZoneOptions: state => state.defaults.timeZoneOptions,
    blockchains: state => state.defaults.blockchains,
    cryptoTypes: state => state.defaults.cryptoTypes,
  },
  actions: {
    [LOAD_SETTINGS]: async ({ dispatch }) => {
      return await dispatch(HTTP_GET, {
        method: LOAD_SETTINGS,
        namespace: 'settings',
        no_commit: true,
      }, { root: true });
    },
    [UPDATE_SETTING]: async ({ dispatch }, { name, setting }) => {
      return await dispatch(HTTP_PUT, {
        method: UPDATE_SETTING,
        namespace: 'settings',
        no_commit: true,
        body: { name, setting },
      }, { root: true });
    },
    [ADD_WHITELIST_WALLET]: async ({ dispatch }, { blockchain, address, token_2fa }) => {
      return await dispatch(HTTP_POST, {
        method: ADD_WHITELIST_WALLET,
        namespace: 'settings',
        no_commit: true,
        body: { blockchain, address, token_2fa },
      }, { root: true });
    },
    [DELETE_WHITELIST_WALLET]: async ({ dispatch }, { blockchain, address, token_2fa }) => {
      return await dispatch(HTTP_DELETE, {
        method: DELETE_WHITELIST_WALLET,
        namespace: 'settings',
        no_commit: true,
        body: { blockchain, address, token_2fa },
      }, { root: true });
    },
  },
  mutations: {
    [LOAD_SETTINGS]: (state, { data }) => {
      for (const settingName of Object.keys(data)) {
        Vue.set(state, settingName, data[settingName]);
      }
    },
  },
};
